import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import Relay from 'react-relay/classic';

import BuyerAssuranceIcon from 'dibs-vg/dist/react/buyer-assurance';
import SecondaryButton from 'dibs-elements/dist/Button/Secondary';
import 'dibs-elements/dist/Button/buyer/Secondary.css';

import { procurementCta as copy } from '../../../../../json/copy/pdp.json';
import styles from './TradeProcurementCta.scss';

import TradeProcurementRenderer from './TradeProcurementRenderer';
import TradeProcurementInfoLink from './TradeProcurementInfoLink';

function ItemInProcurement() {
    return (
        <span className={styles.requestSent} data-tn="request-procurement-sent">
            <BuyerAssuranceIcon className={styles.assuranceIcon} />
            {copy.purchaseRequestSent}
        </span>
    );
}

class TradeProcurementCta extends Component {
    constructor() {
        super();

        this.state = {
            isOpen: false,
        };

        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }
    openModal(event) {
        event.preventDefault();
        this.setState({
            isOpen: true,
        });
    }
    closeModal() {
        this.setState({
            isOpen: false,
        });
    }
    render() {
        const { isOpen } = this.state;
        const { user, item, className } = this.props;
        const itemId = get(item, 'serviceId');
        const itemInProcurement = get(item, 'isInProcurement');
        const isSold = get(item, 'isSold');
        const isOnHold = get(item, 'isOnHold');
        const isVerifiedTrade = get(user, 'isVerifiedTrade');
        const isOutsideSales = get(user, 'tradeFirm.isOutsideSales');

        const canShowCta = isVerifiedTrade && isOutsideSales && !isSold && !isOnHold;

        if (!itemId) {
            return null;
        }

        return (
            <span className={className}>
                {itemInProcurement && <ItemInProcurement />}
                {!itemInProcurement &&
                    canShowCta && (
                        <SecondaryButton
                            onClick={this.openModal}
                            className={styles.button}
                            title={copy.cta}
                            dataTn="request-procurement-service"
                        >
                            {copy.cta}
                        </SecondaryButton>
                    )}
                {!itemInProcurement && canShowCta && <TradeProcurementInfoLink />}
                <TradeProcurementRenderer
                    isOpen={isOpen}
                    closeModal={this.closeModal}
                    itemIds={[itemId]}
                />
            </span>
        );
    }
}

TradeProcurementCta.propTypes = {
    user: PropTypes.object,
    item: PropTypes.object,
    className: PropTypes.string,
};

export default Relay.createContainer(TradeProcurementCta, {
    initialVariables: {
        hasUserId: false,
        userId: null,
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                isVerifiedTrade
                tradeFirm {
                    isOutsideSales
                }
            }
        `,
        item: () => Relay.QL`
            fragment on Item {
                serviceId
                isOnHold
                isSold
                isInProcurement(userId: $userId) @include(if: $hasUserId)
            }
        `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/global/components/TradeProcurement/TradeProcurementCta.jsx